import type { SkillTemplateVersion } from '@/services/skill-template-service';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Button,
} from 'prosci-ui';
import { format } from 'date-fns';

type Props = {
  versions: SkillTemplateVersion[] | undefined;
  onRollbackClick: (versionNumber: number) => void;
};

export function VersionHistoryCard({ versions, onRollbackClick }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Version History</CardTitle>
      </CardHeader>
      <CardContent>
        {versions?.length ? (
          <div className="space-y-3">
            {versions.map((version) => (
              <div
                key={version.id}
                className="flex items-start justify-between border-b pb-2 last:border-0"
              >
                <div>
                  <div className="text-sm font-medium">v{version.version_number}</div>
                  <div className="text-xs text-muted-foreground">
                    {version.change_description || 'No description'}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    {version.created_at
                      ? format(new Date(version.created_at), 'MMM d, yyyy HH:mm')
                      : ''}
                  </div>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onRollbackClick(version.version_number)}
                >
                  Rollback
                </Button>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-muted-foreground">No versions yet</p>
        )}
      </CardContent>
    </Card>
  );
}
